export default __webpack_public_path__ + "static/media/vMTA.1b5a740a.svg";